

class Counter {

    getSpeed(counter) {
        return parseFloat(counter.dataset.duration);
    };

    getNumber(counter){
        return parseFloat(counter.dataset.target.replaceAll('.', '').replaceAll(',', ''));
    };

    updateText(counter, text){
        counter.textContent = text;
    };

    animate(counter, countTo, duration){
        let startTime = null;

        let currentTime = Date.now();

        const step = (currentTime) => {
            if (!startTime) {
                startTime = currentTime;
            }

            const progress = Math.min((currentTime - startTime) / duration, 1);

            const currentNum = Math.floor(progress * countTo);

            this.updateText(counter, currentNum);

            if (progress < 1) {
                window.requestAnimationFrame(step);
            } else {
                window.cancelAnimationFrame(window.requestAnimationFrame(step));
            }
        };

        window.requestAnimationFrame(step);
    };


    inViewport(elem){
        let allElements =  document.querySelectorAll(elem);
        let windowHeight = window.innerHeight;

        const elems = () => {
            for (let i = 0; i < allElements.length; i++) {  //  loop through the sections
                let viewportOffset = allElements[i].getBoundingClientRect();  //  returns the size of an element and its position relative to the viewport
                let top = viewportOffset.top;  //  get the offset top
                if(top < windowHeight){  //  if the top offset is less than the window height
                    if(!allElements[i].classList.contains('counting-done')) {
                        const countTo = this.getNumber(allElements[i]);
                        const duration = this.getSpeed(allElements[i]);
                        this.animate(allElements[i], countTo, duration);
                        allElements[i].classList.add('counting-done');
                    }

                }
            }
        }
        elems();
        window.addEventListener('scroll', elems);
    }

}

window.counter = new Counter();